<div class="row position-relative whiteSection contentSize"  [dir]="this.apiService.currentDirection" style="border-bottom: 0"
     [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
  <div class="col-12" style="background-color: #ffc200;height: 200px;background-image: url('../../../assets/img/contact-background.jpg');background-size: cover; background-repeat: no-repeat"></div>

    <div class="col-12 col-md-10 col-lg-6 mx-auto boxShadow contactInfo">
      <div class="row">
        <div class="col-12 col-md-7 p-3">
          <h4 class="bold my-5">{{'Feedback'|translate}}</h4>
          <div>
            <mat-form-field class="example-full-width mx-1 ">
              <mat-label>{{'Name'|translate}} </mat-label>
              <input matInput [(ngModel)]="name" id="name" [disabled]="disable"
                     [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="example-full-width mx-1">
              <mat-label> {{'Email'|translate}} </mat-label>
              <input matInput [(ngModel)]="email" id="email" class="leftSideText" [disabled]="disable"
                     [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="example-full-width mx-1">
              <mat-label>{{'Message'|translate}}</mat-label>
              <textarea matInput cols="30" [(ngModel)]="message" id="message" [disabled]="disable"
                        [ngModelOptions]="{standalone: true}"></textarea>
            </mat-form-field>
          </div>
          <div>
            <button class="btn ptn-primary custom-btn my-5" (click)="sendFeedback()">{{'Send'|translate}}</button>
          </div>

        </div>
        <div class="col-12 col-md-5">
          <div class="my-5 pt-5">
            <div class="row my-3 pt-5">
              <span class="infoIcon">
                 <i class="fa fa-phone  fa-lg"></i>
            </span>
              <a href="tel:+987132318040" class="mt-2 px-3 text-left" [dir]="'ltr'">
                +987132318040
              </a>
            </div>


            <div class="row my-4 ">
              <span class="infoIcon">
                 <i class="fa fa-envelope  fa-lg"></i>
            </span>

              <a href="mailto:info@alobodo.com" class="mt-2 px-3 text-left">
                info@alobodo.com
              </a>
            </div>


            <div class="row my-4">
              <span class="infoIcon">
                 <i class="fa fa-map-marker  fa-lg"></i>
               </span>

              <p class="mt-2 px-3 ">{{'Address'|translate}}</p>

            </div>

          </div>
        </div>


      </div>
    </div>
<!--  <div class="whiteSection">-->
<!--vv-->
<!--  </div>-->

</div>

<div style="min-height: 300px">

</div>



